(function () {
  'use strict';

  var copy = {
    en: {timer:'Early access ends in',days:'Days',hours:'Hours',minutes:'Minutes',seconds:'Seconds',hTitle:'Halloween Early Access · 18% Off',hCopy:'Applied automatically at checkout. No code needed.',wTitle:'10% Off Your First Order',wCopy:'Use this code on other eligible styles.',cartTitle:'Your available offers',cartCopy:'Halloween styles receive 18% off automatically. First order? Use WELCOME10 on other eligible styles.',cartNote:'Offers cannot be combined on the same item.',button:'Copy code',copied:'Copied',announcement:'🎃 Halloween Early Access · 18% Off · Ends September 30'},
    de: {timer:'Vorabaktion endet in',days:'Tage',hours:'Std.',minutes:'Min.',seconds:'Sek.',hTitle:'Halloween-Vorabaktion · 18 % Rabatt',hCopy:'Wird im Checkout automatisch abgezogen. Kein Code nötig.',wTitle:'10 % Rabatt auf deine erste Bestellung',wCopy:'Nutze diesen Code für andere teilnehmende Styles.',cartTitle:'Deine verfügbaren Angebote',cartCopy:'Auf Halloween-Styles werden 18 % automatisch abgezogen. Erste Bestellung? Nutze WELCOME10 für andere teilnehmende Styles.',cartNote:'Rabatte sind für denselben Artikel nicht kombinierbar.',button:'Code kopieren',copied:'Kopiert',announcement:'🎃 Halloween-Vorabaktion · 18 % Rabatt · Bis 30. September'},
    fr: {timer:'Fin de l’avant-première dans',days:'Jours',hours:'Heures',minutes:'Min.',seconds:'Sec.',hTitle:'Offre Halloween en avant-première · -18 %',hCopy:'Remise appliquée automatiquement au paiement. Aucun code requis.',wTitle:'-10 % sur votre première commande',wCopy:'Utilisez ce code sur les autres articles éligibles.',cartTitle:'Vos offres disponibles',cartCopy:'La sélection Halloween bénéficie automatiquement de -18 %. Première commande ? Utilisez WELCOME10 sur les autres articles éligibles.',cartNote:'Les remises ne sont pas cumulables sur un même article.',button:'Copier le code',copied:'Copié',announcement:'🎃 Offre Halloween en avant-première · -18 % · Jusqu’au 30 septembre'}
  };

  var config = document.getElementById('yeese-campaign-config');
  var locale = ((config && config.dataset.locale) || document.documentElement.lang || 'en').slice(0,2).toLowerCase();
  var t = copy[locale] || copy.en;

  function localizeAnnouncement() {
    document.querySelectorAll('a[href*="/collections/halloween"]').forEach(function (link) {
      if (/Halloween Collection|Halloween Early Access|Halloween-Vorabaktion|Offre Halloween/.test(link.textContent) && link.textContent !== t.announcement) {
        link.textContent = t.announcement;
      }
    });
  }

  function setupCountdown(root) {
    var deadline = new Date(root.dataset.deadline).getTime();
    if (!Number.isFinite(deadline)) return;
    root.querySelector('[data-countdown-title]').textContent = t.timer;
    [['days',t.days],['hours',t.hours],['minutes',t.minutes],['seconds',t.seconds]].forEach(function (item) {
      root.querySelector('[data-label-' + item[0] + ']').textContent = item[1];
    });
    function update() {
      var left = Math.max(0, deadline - Date.now());
      var seconds = Math.floor(left / 1000);
      var values = {days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),seconds:seconds%60};
      Object.keys(values).forEach(function (key) { root.querySelector('[data-' + key + ']').textContent = String(values[key]).padStart(2,'0'); });
      if (!left) root.querySelector('[data-countdown-title]').textContent = root.dataset.expiredText || '';
    }
    update(); window.setInterval(update, 1000);
  }

  function bindCopy(scope) {
    scope.querySelectorAll('[data-copy-code]:not([data-copy-bound])').forEach(function (button) {
      button.dataset.copyBound = 'true'; button.textContent = t.button;
      button.addEventListener('click', function () {
        var code = button.dataset.copyCode;
        var done = function () { button.textContent = t.copied; window.setTimeout(function(){button.textContent=t.button;},1600); };
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done);
        else { var input=document.createElement('textarea'); input.value=code; document.body.appendChild(input); input.select(); document.execCommand('copy'); input.remove(); done(); }
      });
    });
  }

  function mountProduct() {
    if (document.querySelector('.yeese-promo--product')) return;
    var anchor = document.querySelector('.product-info__price');
    var template = document.getElementById('yeese-product-promo-template');
    if (!anchor || !template) return;
    var node = template.content.firstElementChild.cloneNode(true);
    var halloween = Boolean(config && config.dataset.halloweenProduct === 'true');
    node.querySelector('[data-promo-title]').textContent = halloween ? t.hTitle : t.wTitle;
    node.querySelector('[data-promo-copy]').textContent = halloween ? t.hCopy : t.wCopy;
    if (halloween) node.querySelector('[data-code-row]').remove();
    anchor.insertAdjacentElement('afterend', node); bindCopy(node);
  }

  function mountCart() {
    var drawer = document.querySelector('cart-drawer, .js-cart-drawer');
    if (!drawer || drawer.querySelector('.yeese-promo--cart')) return;
    var anchor = drawer.querySelector('.cart-drawer__footer');
    var template = document.getElementById('yeese-cart-promo-template');
    if (!anchor || !template) return;
    var node = template.content.firstElementChild.cloneNode(true);
    node.querySelector('[data-cart-title]').textContent=t.cartTitle;
    node.querySelector('[data-cart-copy]').textContent=t.cartCopy;
    node.querySelector('[data-cart-note]').textContent=t.cartNote;
    anchor.insertAdjacentElement('beforebegin',node); bindCopy(node);
  }

  function init() {
    localizeAnnouncement();
    document.querySelectorAll('[data-yeese-countdown]').forEach(setupCountdown);
    mountProduct(); mountCart(); bindCopy(document);
    new MutationObserver(function(){localizeAnnouncement();mountProduct();mountCart();}).observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
